<div class="basin-display-flex basin-justify-content-space-between basin-align-items-center basin-mb-2">

  <div class="basin-color-green-75 basin-font-weight-400 basin-subtitle-small"
    *ngIf="simulationService.simulationState === SimulationState.Completed">
    Completion Time
  </div>
  <span class="basin-color-green-75 basin-subtitle-small">{{ getSimulationTime() }}</span>
</div>

<div class="basin-display-flex basin-flex-column">
  <app-detail-field label="Initiation Points" [value]="renderService.runDetails?.initiationPointsCount"></app-detail-field>
  <app-detail-field label="Landslides" [value]="renderService.runDetails?.landslideCount"></app-detail-field>
  <app-detail-field label="Agents" [value]="renderService.runDetails?.agentCount"></app-detail-field>
  <app-detail-field label="Cells" [value]="renderService.runDetails?.cellCount"></app-detail-field>
</div>

<div class="basin-display-flex basin-flex-column basin-mt-2" *ngIf="(debuggerAccess$ | async)">
  <app-detail-field *ngIf="simulationService.simulationState !== SimulationState.Ready"
    [label]="'Complexity Rating'" [value]="renderService.runDetails?.complexityRating"></app-detail-field>
</div>
